import { Typography, Box, Stack, Pagination } from "@mui/material";
import { useTheme } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import useProtectedClient from "../../../hooks/useProtectedClient";
import { getAdminGoldBox } from "../../../api/admin/adminGoldBoxApi";
import ProductRowLoader from "../../marketWidget/productRow/ProductRowLoader";
import { useNotification } from "../../../context/NotificationProvider";
import AdminGoldBoxItem from "./AdminGoldBoxItem";
import SearchBar from "../../base/SearchBar/SearchBar";
import BaseFilter from "../../base/BaseFilter/BaseFilter";
import { GOLD_BOX_STATUS } from "../../../utils/constants";

const AdminGoldBoxList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const protectedClient = useProtectedClient();
  const { showNotification } = useNotification();
  const [goldbox, setGoldBox] = useState([]);
  const [itemsCount, setItemsCount] = useState(0);
  const [totalGold, setTotalGold] = useState(0);
  const [totalMoney, setTotalMoney] = useState(0);
  const [goldPrice, setGoldPrice] = useState(0);
  
  const page = useRef(1);
  const searchQuery = useRef("");
  const selectedStatus = useRef("all");
  const size = 5;

  const filterItems = [
    { id: "all", title: "همه" }, 
    ...Object.entries(GOLD_BOX_STATUS).map(([key, value]) => ({
      id: key,
      title: value.title,
    })),
  ];

  const fetchGoldBox = async () => {
    try {
        setIsLoading(true);
        const statusFilter = selectedStatus.current === "all" ? "" : selectedStatus.current;
        const res = await getAdminGoldBox(protectedClient, searchQuery.current, page.current, size, statusFilter);
        
        setGoldBox(res.items);
        setTotalGold(res.totalGoldWeight);
        setTotalMoney(res.totalValue);
        setGoldPrice(res.goldPriceSell);
        setItemsCount(res.pagination.totalItems);
    } catch (error) {
        showNotification(error, "error");
    } finally {
        setIsLoading(false);
    }
  };

  const handleSearch = (query) => {
    searchQuery.current = query;
    page.current = 1;
    fetchGoldBox();
  };

  const handlePageChange = (event, value) => {
    page.current = value;
    fetchGoldBox();
  };

  const handleFilterChange = (status) => {
    selectedStatus.current = status
    page.current = 1;
    fetchGoldBox();
  };

  useEffect(() => {
    fetchGoldBox();
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      padding={2}
      sx={{
        height: "90vh",
        width: "100%",
        marginBottom: "100px",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <Box display="flex" flexDirection="row" gap="24px" justifyContent="space-between" alignItems="center" width="100%">
        <SearchBar onSearch={handleSearch} />
        <BaseFilter items={filterItems} defaultValue={selectedStatus.current} onFilterChange={handleFilterChange} label="وضعیت" />
      </Box>

      <Stack>
        <Pagination
          count={Math.ceil(itemsCount / size)}
          page={page.current}
          onChange={handlePageChange}
          color="primary"
          size="large"
          shape="circular"
          siblingCount={0}
          boundaryCount={1}
        />
      </Stack>

      {!isLoading ? (
        <>
          {goldbox.map((item, index) => (
            <AdminGoldBoxItem key={index} item={item} />
          ))}
        </>
      ) : (
        <>
          <ProductRowLoader />
          <ProductRowLoader />
          <ProductRowLoader />
        </>
      )}
    </Box>
  );
};

export default AdminGoldBoxList;
